export default "__VITE_ASSET__C3lbnuWG__"